var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99935 7.33398L7.66602 1.33398L11.3327 7.33398H3.99935ZM8.95268 6.00065L7.66602 3.89398L6.37268 6.00065H8.95268ZM11.3327 8.66732C9.67268 8.66732 8.33268 10.0073 8.33268 11.6673C8.33268 13.3273 9.67268 14.6673 11.3327 14.6673C12.9927 14.6673 14.3327 13.3273 14.3327 11.6673C14.3327 10.0073 12.9927 8.66732 11.3327 8.66732ZM9.66602 11.6673C9.66602 12.5873 10.4127 13.334 11.3327 13.334C12.2527 13.334 12.9993 12.5873 12.9993 11.6673C12.9993 10.7473 12.2527 10.0007 11.3327 10.0007C10.4127 10.0007 9.66602 10.7473 9.66602 11.6673ZM1.66602 14.334H6.99935V9.00065H1.66602V14.334ZM5.66602 10.334H2.99935V13.0007H5.66602V10.334Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.2f3a5b357af8e19732a4727d411b9940.svg";
export { ForwardRef as ReactComponent };